import {
  NO_RESULT_ADVICE,
  VerificationCheckCard,
} from "../../license-verification/verification-check-card";
import { CheckRecoveryNotice } from "../check-recovery-notice";
import type { RunReport, RunScope } from "../types";

const FAILED_CHECK_STATUSES = new Set<string>(["failed", "blocked"]);

export type LicenseItem = RunReport["licenses"][number];
export type LicenseSourceItem = LicenseItem["sources"][number];
export type SourceCheck = RunReport["checks"][number];

/** One source's evidence for a license. A source that returned a result for
 * the license shows that result and its evidence; one that returned none
 * (failed, manual, still running) says what happened instead. A source that
 * does not decide the license is shown as information, not as issues. */
export function LicenseSourceDetails({
  source,
  check,
  runId,
  scope,
  showIssues,
}: {
  source: LicenseSourceItem;
  check: SourceCheck;
  runId: string;
  scope: RunScope;
  /** False when the item's banner states this source's issues. */
  showIssues: boolean;
}) {
  if (source.resultKey) {
    return (
      <VerificationCheckCard
        check={check}
        runId={runId}
        scope={scope}
        embedded
        resultKey={source.resultKey}
        informational={!source.decides}
        showIssues={showIssues}
      />
    );
  }
  return (
    <div className="space-y-2 text-sm text-muted-foreground">
      {/* The deciding source's description is the license's, shown above. */}
      {!source.decides && <p>{check.assessment.description}</p>}
      {check.recovery && <CheckRecoveryNotice recovery={check.recovery} />}
      {!check.recovery && FAILED_CHECK_STATUSES.has(check.status) && (
        <p>{NO_RESULT_ADVICE}</p>
      )}
    </div>
  );
}
